import React, { useEffect, useState } from "react";
import { apiGet } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { Lock, Crown } from "lucide-react";
import MotionButton from "./motion/MotionButton";

export default function FreeTrialBanner({ compact = false }) {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    apiGet("/free/status").then(setStatus).catch(() => {});
  }, []);

  if (!status?.is_free) return null;
  const { attempts_used, max_attempts, max_pool, exhausted, attempts_remaining } = status;

  if (exhausted) {
    return (
      <div
        data-testid="free-trial-exhausted"
        className="border border-brand-red/40 bg-gradient-to-br from-brand-red/8 via-brand-surface to-brand-green/8 rounded-2xl p-5 sm:p-6 mb-6"
      >
        <div className="flex items-start gap-4">
          <div className="h-11 w-11 rounded-xl bg-brand-red/15 text-brand-red flex items-center justify-center shrink-0">
            <Lock className="h-5 w-5" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="eyebrow text-brand-red mb-1.5">// Prova gratuita esaurita</div>
            <div className="font-serif text-2xl font-semibold text-brand-primary leading-tight">
              Hai finito le tue {max_pool} domande gratis ({max_attempts} tentativi).
            </div>
            <p className="mt-2 text-sm text-brand-secondary leading-relaxed">
              Per sbloccare il resto del banco di <span className="text-brand-primary font-medium">1.500 domande</span> e
              le simulazioni illimitate, passa a Premium.
            </p>
            <MotionButton
              data-testid="free-trial-upgrade-btn"
              variant="red"
              size="md"
              className="mt-5"
              onClick={() => navigate("/premium")}
            >
              <Crown className="h-4 w-4" /> Passa a Premium
            </MotionButton>
          </div>
        </div>
      </div>
    );
  }

  if (compact) {
    return (
      <div
        data-testid="free-trial-banner"
        className="border border-brand-gold/40 bg-brand-gold/8 rounded-xl p-3 mb-4 text-xs flex items-center gap-2"
      >
        <Lock className="h-3.5 w-3.5 text-brand-gold shrink-0" />
        <span className="text-brand-primary">
          Prova gratis: {attempts_used}/{max_attempts} tentativi ·{" "}
          <button
            onClick={() => navigate("/premium")}
            className="gold-link font-medium"
          >
            Sblocca le 1.500 domande
          </button>
        </span>
      </div>
    );
  }

  return (
    <div
      data-testid="free-trial-banner"
      className="border border-brand-gold/40 bg-brand-gold/8 rounded-2xl p-5 mb-6"
    >
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-start gap-3 min-w-0 flex-1">
          <Lock className="h-4 w-4 text-brand-gold mt-0.5 shrink-0" />
          <div className="min-w-0">
            <div className="text-sm font-medium text-brand-primary">
              Prova gratuita: {attempts_remaining} tentativi rimasti su {max_attempts}
            </div>
            <div className="text-xs text-brand-secondary mt-1 leading-relaxed">
              Vedrai sempre le stesse {max_pool} domande della prova. Per accedere a tutto il banco passa a Premium.
            </div>
          </div>
        </div>
        <MotionButton
          data-testid="free-trial-upgrade-btn"
          variant="primary"
          size="sm"
          onClick={() => navigate("/premium")}
        >
          Sblocca tutto
        </MotionButton>
      </div>
    </div>
  );
}
